import i18n from 'i18next';
import { countDate } from '../../../../actions/date';
import { STATUS_MAP } from '../../../../constants/statuses';

export default ({ value, type }) => {
    if (!value) return '-';

    const isStatusHistory = type === 'status_history';

    const GROUP_STATUSES = {
        0: 'usual',
        1: 'candidate',
        2: 'promo',
        3: 'summer_intensive',
        4: 'bingo',
        5: 'cube',
        7: 'delete',
        8: 'issue',
    };

    const statuses = isStatusHistory ? STATUS_MAP : GROUP_STATUSES;
    const translationPrefix = isStatusHistory ? 'users.' : 'groups.';

    let title = '';
    let history = '';

    for (let i in value.sort((a, b) => +new Date(b.date) - +new Date(a.date))) {
        const item = value[i];
        const dateValue = isStatusHistory ? item.date : item.created_at;
        const date = countDate(dateValue, true);

        history += `${date} | ${i18n.t(translationPrefix + statuses[item.status])}\n`;
        if (+i === 0) title = date;
    }
    return value ? (
        <div
            style={{
                display: 'block',
                whiteSpace: 'nowrap',
                maxWidth: 250,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }}
            title={history}
            children={title}
        />
    ) : (
        '-'
    );
};
